// 検索モーダル表示(検索アイコン押下時)
const openSearchModal = () =>{
  const searchModal = document.querySelector('#SearchModal');
  const searchModalDetails = searchModal.querySelector('details');
  searchModal.classList.remove("hidden")
  searchModalDetails.setAttribute("open",true);
}

// 検索モーダル閉じる
const cloasSearchModal = () =>{
  const searchModal = document.querySelector('#SearchModal');
  const searchModalDetails = searchModal.querySelector('details');
  searchModal.classList.add("hidden")
  searchModalDetails.removeAttribute("open");
}
